
// Import Vendors
import FarloUiLightbox from './vendors/farlo-ui-lightbox';
import FarloUiSelectBox from './vendors/farlo-ui-selectbox';
//import FarloUiRevolverCarousel from './vendors/farlo-ui-revolver-carousel';
import Flickity from "flickity-fullscreen";
import FarloUiTicketCalendar from './vendors/farlo-ui-ticket-calendar.js';
import FarloUiWhatsOnCalendar from './vendors/farlo-ui-whats-on-calendar.js';
import FarloUiAccessibleCalendar from './vendors/farlo-ui-accessible-performances.js';

// Import Footer Components
import { mapLoader } from './components/footer/mapLoader.js';
import { farloUiCrmSignup } from './components/footer/farloUiCrmSignup.js';
import { elementInView } from './components/footer/elementInView.js';
import { toggleFAQ } from './components/footer/faqs.js';
import { navigation, navicon, searchIcon } from './components/footer/navigation.js';
import { ticker } from './components/footer/ticker.js';
import { formDates } from './components/footer/formDates.js';
import { handleNavigation } from './components/footer/handleNavigation.js';
import { expand } from './components/footer/expand.js';
import { genreFilter } from './components/footer/genreFilter.js';
//import { draggableSlider } from './components/footer/draggableSlider.js';
import { particles } from './components/footer/particles.js';
import { newsFilter, filterPosts } from './components/footer/newsFilter.js';
import { showContents } from './components/footer/showContents.js';
import { careersExpand } from './components/footer/careersExpand.js';
import { addScrolledClass } from './components/footer/addScrolledClass.js';
import { handleMenuHover } from './components/footer/handleMenuHover.js';
import { directionsFilter } from './components/footer/directionsFilter.js';
import { eventSlider } from './components/footer/eventSlider.js';
import { smoothScroll } from './components/footer/smoothScroll.js';
import { mastheadSlideAutoplay } from './components/footer/mastheadSlideAutoplay.js';
import { setTallestTimelineItemHeight } from './components/footer/setTallestTimelineHeight.js';
import { stickyKeyInfo } from './components/footer/stickyKeyInfo.js';
import { photogalleryVideoIntro } from './components/footer/photogalleryVideoIntro.js';


const youTubeRegex = RegExp(/(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/ ]{11})/i);


((document, window, history) => {
	const pushState = history.pushState;

	history.pushState = function(state) {
		if (typeof history.onpushstate === 'function') {
			history.onpushstate({ state });
		}
		return pushState.apply(history, arguments);
	};

	

	document.addEventListener('DOMContentLoaded', () => {
		if (document.querySelector('.site-navigation__navicon')) {
			navicon();
	
		}

		document.querySelectorAll('a[href^="#"]').forEach(anchor => {
			smoothScroll(anchor);
		});

		if (document.querySelector('#event-key-info')){
			stickyKeyInfo();
		}
		
		if (document.querySelector('.site-navigation__search')) {
			searchIcon();
		}
		if(document.querySelector('.site-event-details__contents--show-more')){
			showContents();
		}

		if (document.querySelector('.transportations')){
			directionsFilter();
		}
		if (document.querySelector('.site-masthead__ticker')){
			ticker();
		} 

		if (document.querySelector('.site-header')){
			addScrolledClass();
		}

		if(document.querySelector('.site-masthead__slides')){
			mastheadSlideAutoplay();
		}
		if (document.querySelector('.farlo-whats-on__filters-categories__list-item-link')){
			genreFilter();
		}
		document.querySelectorAll("#menu-primary-menu > .menu-item > a").forEach(_item => {
			_item.addEventListener("click", () => {
					document.querySelectorAll(".site-navigation__menu-item--active").forEach(_active => {
						_active.classList.remove("site-navigation__menu-item--active");
					});
			});
		})
		if (document.querySelector('.site-navigation__sub-menu')) {
			document.querySelectorAll('.site-navigation__sub-menu').forEach((_sel) => {
				navigation(_sel);
			});
		}

		if (document.querySelector('.menu-item')){
			handleMenuHover();
		}

		if (document.querySelector('[data-initialise-flickity="mobile-slider"]')){
			const flickitySelector = '[data-initialise-flickity="mobile-slider"]';
			let flickityInstances = [];
		
			function initFlickity() {
				const elements = document.querySelectorAll(flickitySelector);
				elements.forEach((element, index) => {
					if (!element.flickityInstance && window.innerWidth < 980) {
						flickityInstances[index] = new Flickity(element, {
							cellAlign: 'center',
							pageDots: false,
							wrapAround: false,
						});
						element.flickityInstance = flickityInstances[index];
					} else if (element.flickityInstance && window.innerWidth >= 980) {
						element.flickityInstance.destroy();
						delete element.flickityInstance;
					}
				});
			}
		
			// Initial check
			initFlickity();
		
			// Re-initialize on resize
			window.addEventListener("resize", function () {
				initFlickity();
			});
		
		}

		if (document.querySelector('#slider')){
			eventSlider();
		}

		if (document.querySelector('.site-photogallery__video-intro')) {
			photogalleryVideoIntro();
		}

		if (document.querySelector('.timeline')) {
		
			setTallestTimelineItemHeight()
		}

		document.querySelectorAll('[data-ui="carousel"]').forEach(_sel => {
	
				var flkty = new Flickity( _sel, {
					draggable:true, 
					pageDots:true,
					prevNextButtons:false, 
					wrapAround: true, 
					freeScroll : false,
					//contain: true,
					//cellAlign:"middle", 
					adaptiveHeight: true,
					on: {
					
						}
				});
			
		});
		

		if (document.querySelector('.menu-item-has-children')){
			handleNavigation();
		}

		if (document.querySelector('.site-event-details__secondary-description')) {
			expand();
		}

		if (document.querySelector('#input_1_9')){
			formDates();
		}

		if (document.querySelector('.farlo-ui-crm--inline')) {
			document.querySelectorAll('[farlo-ui="crm"]').forEach((_sel) => {
				farloUiCrmSignup(_sel);
			});
		}

		if (document.querySelector('.farlo-ui-crm__toggle')) {
			document.querySelectorAll('.farlo-ui-crm__toggle').forEach((_sel) => {
				_sel.addEventListener('click', (e) => {
					e.preventDefault();
					e.stopImmediatePropagation();
					farloUiCrmSignup(e);
				});
			});
		}

		if (document.querySelector('.location-filter')){
			filterPosts();
			newsFilter();
		}

		if (document.querySelector('.rank-math-list-item')){
			document.querySelectorAll(".rank-math-question").forEach((_el) => {
                _el.dataset.toggled = "0";
                _el.addEventListener("click", () => {
                    toggleFAQ(_el);
                })
            });
		}

		if (document.querySelector('.farlo-ui-animated')) {
			document.querySelectorAll('.farlo-ui-animated').forEach((_sel) => {
				elementInView(_sel);
			});
		}

		if (document.querySelector('.careers__list-item')){
			careersExpand();
		}

		if (document.querySelector('.farlo-ui-ticket-calendar' && '[farlo-ui="calendar"]')) {
			document.querySelectorAll('[farlo-ui="calendar"]').forEach((_sel) => {
				new FarloUiTicketCalendar(_sel);
			});
		}

		if (document.querySelector('.farlo-ui-ticket-calendar' && '[farlo-ui="whats-on-calendar"]')) {
			document.querySelectorAll('[farlo-ui="whats-on-calendar"]').forEach((_sel) => {
				new FarloUiWhatsOnCalendar(_sel);
			});
		}

		if (document.querySelector('.farlo-ui-ticket-calendar' && '[farlo-ui="accessible-calendar"]')) {
			document.querySelectorAll('[farlo-ui="accessible-calendar"]').forEach((_sel) => {
				new FarloUiAccessibleCalendar(_sel);
			});
		}

		if (document.querySelector('form')) {
			document.querySelector('form').querySelectorAll('select').forEach((_sel) => {
				new FarloUiSelectBox(_sel);
			});
		}

		if (document.querySelector('.farlo-ui-lightbox__toggle')) {
			document.querySelectorAll('.farlo-ui-lightbox__toggle').forEach((_sel) => {
				new FarloUiLightbox(_sel);
			});
		}

		function enableRecaptcha() {
			const recaptcha = document.querySelector('[data-recaptcha]');
			if (recaptcha && !recaptcha.src) {
				recaptcha.src = recaptcha.dataset.src;
			} 
		}

		if (document.querySelector("[data-toggle='crm-overlay']")) {
			document.querySelectorAll("[data-toggle='crm-overlay']").forEach(_sel => {
				_sel.addEventListener("click", () => {
					const lightbox = document.querySelector(".newsletter-lightbox");
					if (lightbox) {
						lightbox.querySelector('[data-prompt]').textContent = _sel.dataset.prompt;
						lightbox.querySelector('[data-subtitle]').textContent = _sel.dataset.subtitle;
				
						if (_sel.dataset.img) {
							lightbox.querySelector('[data-img]').innerHTML = `<img style="margin-top:32px;margin-bottom:16px;" class="has-border-radius-1" src="${_sel.dataset.img}" alt="${_sel.dataset.prompt}" />` ;
						}
						lightbox.classList.add("farlo-ui-lightbox--active");
						enableRecaptcha();	
					}
				})
			});
		}
		if (document.querySelector("[data-toggle='groups-overlay']")) {
				const overlayButtons = document.querySelectorAll("[data-toggle='groups-overlay']");
				if (!overlayButtons.length) return;

				overlayButtons.forEach(btn => {
				btn.addEventListener("click", function () {
					const lightbox = document.querySelector(".groups-lightbox");
					if (!lightbox) return;

					lightbox.querySelector('[data-prompt]').textContent   = btn.dataset.prompt;
					lightbox.querySelector('[data-subtitle]').textContent = btn.dataset.subtitle;
					if (btn.dataset.img) {
					lightbox.querySelector('[data-img]').innerHTML = `
						<img 
						style="margin-top:32px;margin-bottom:16px;" 
						class="has-border-radius-1" 
						src="${btn.dataset.img}" 
						alt="${btn.dataset.prompt}" 
						/>
					`;
					}
					if (btn.dataset.product) {
						lightbox.querySelector('#input_4_16').value = btn.dataset.product ;
					}
					if (btn.dataset.product) {
						lightbox.querySelector('#input_4_15').value = btn.dataset.type ;
					}
					const startDate = new Date(btn.dataset.start);
					const endDate   = new Date(btn.dataset.end);

					const dateField = lightbox.querySelector('.restrict-dates input');
					if (dateField) {
					jQuery(dateField).datepicker('option', {
						minDate: startDate,
						maxDate: endDate
					});
					}

					lightbox.classList.add("farlo-ui-lightbox--active");
					enableRecaptcha();	
				});
				});
		}
		if (document.querySelector("#gform_2")) {
			enableRecaptcha();
		}

		function initializeCarousel(selector) {
			document.querySelectorAll(selector).forEach((_sel) => {
				var flkty = new Flickity( _sel, {});
			});
		}
	
		document.querySelectorAll(".site-collapsible-section__header").forEach(_sel => {
			_sel.addEventListener("click", () => {
				const contentSection = _sel.nextElementSibling;
				if (contentSection) {
					_sel.classList.toggle("site-collapsible-section__open");
					contentSection.style.setProperty('--section-height', (contentSection.clientHeight ? 0 : contentSection.scrollHeight));
				}

			})
		});
	
		// Initialize existing carousels
		if (document.querySelector('.farlo-ui-revolver-carousel')) {
			initializeCarousel('.farlo-ui-revolver-carousel');
			
		}
		
		if (document.querySelector("#event-key-info__toggle")) {
			const eventInfoToggle = document.querySelector("#event-key-info__toggle");
			eventInfoToggle.addEventListener("click", () => {
				document.body.classList.toggle("event-key-info--open");
			})
		}

		document.querySelectorAll(".has-media-video").forEach((_sel) => {
			_sel.addEventListener("click", () => {
				if (_sel.parentElement.classList.contains("flickity-cell")) {
					return true;
				}
				const videoSelector = document.createElement("div");
				videoSelector.classList.add("has-media-video__active");
				videoSelector.innerHTML = '<iframe class="farlo-ui-lightbox__inner-content-iframe" src="https://www.youtube-nocookie.com/embed/' + _sel.dataset.video.match(youTubeRegex)[ 1 ] + '?autoplay=1&rel=0" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>';
				_sel.appendChild(videoSelector);
			})
		})
	});

	if (document.querySelector('.farlo-ui-map')) {
		mapLoader();
	}

	if (typeof navigator !== 'undefined') {
		navigator.serviceWorker.getRegistrations().then(function(registrations) {
			for (const registration of registrations) {
				registration.unregister();
			}
		});
	}

	window.toggleFullscreen = (_sel, _idx) => {

		const sel = document.querySelector(".site-photogallery__carousel");
		if (sel) {
			sel.parentElement.style.display = "block";
			const flkty = window.Flickity.data(sel);
			flkty.toggleFullscreen();
			if (!!_idx) {
				flkty.select(_idx);
			}
			flkty.on("change", (_idx) => {
				sel.querySelectorAll(".has-media-video__active").forEach(_v => {
					_v.remove();
				})
			});
			flkty.on( 'dragStart', ( event, pointer ) => {
				sel.querySelectorAll(".has-media-video__active").forEach(_v => {
					_v.remove();
				})		
			});
			flkty.on( 'staticClick', ( event, pointer ) => {
				const _sel = pointer.target;
				if (_sel.classList.contains("has-media-video")) {
					
					const videoSelector = document.createElement("div");
					videoSelector.classList.add("has-media-video__active");
					videoSelector.innerHTML = '<iframe class="farlo-ui-lightbox__inner-content-iframe" src="https://www.youtube-nocookie.com/embed/' + _sel.dataset.video.match(youTubeRegex)[ 1 ] + '?autoplay=1&rel=0" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>';
					_sel.appendChild(videoSelector);
					
				}
			})
		}
		document.querySelector(".flickity-fullscreen-button-exit").addEventListener("click", () => {
			sel.parentElement.style.display = "none";
			sel.querySelectorAll(".has-media-video__active").forEach(_v => {
				_v.remove();
			})
		});
	}

	window.addEventListener("load", () => {
		document.body.classList.add("loaded");
		if (document.querySelector('#particles-js')){
			particles();
		}
	})

	let resizeTimer;
    window.addEventListener("resize", () => {
      document.body.classList.add("resize-animation-stopper");
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        document.body.classList.remove("resize-animation-stopper");
      }, 400);
    });

})(document, window, history);
